import React from 'react';
import { Sidebar } from './Sidebar';
import { ListQuestions } from './ListQuestions';
import { ContentQuestion } from './ContentQuestion';
import { UpdateQuestionBookProvider } from './provider';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';

export const UpdateQuestionBook = () => (
  <Dashboard>
    <UpdateQuestionBookProvider>
      <Sidebar />

      <DashboardContent
        viewMode="create"
        className="md:!px-0 md:!py-0"
      >
        <div className="new-questions">
          <ListQuestions />

          <ContentQuestion />
        </div>
      </DashboardContent>
    </UpdateQuestionBookProvider>
  </Dashboard>
);
